import { ExtractActions, triggerOverlay } from '@vfde-fe/sails_core';
import {
    CREATE_INITIAL_STATE,
    DELETE_SELECTED_TRADE_IN_DEVICE,
    GET_TRADE_IN_DEVICES,
    GET_TRADE_IN_DEVICES_FAILED,
    GET_TRADE_IN_DEVICES_SUCCESS,
    SET_TRADE_IN_DEVICE,
    SET_DEFAULT_STATE,
    SET_SUGGEST_FIELD_VALUE,
    TOGGLE_TRADE_IN_SWITCH,
} from './constants';
import { Device } from './interfaces/api';

/**
 * createInitialState
 */
const createInitialState = () => ({
    type: CREATE_INITIAL_STATE,
});

/**
 * Set default state
 * @param tradeInSwitch
 */
const setDefaultState = (tradeInSwitch: boolean) => ({
    type: SET_DEFAULT_STATE,
    tradeInSwitch,
});

/**
 * Get Devices
 *
 */
const getTradeInDevices = () => ({
    type: GET_TRADE_IN_DEVICES,
});

/**
 * Fire when API request success
 * @param payload
 */
const getTradeInDevicesSuccess = (payload: Device[] | null) => ({
    type: GET_TRADE_IN_DEVICES_SUCCESS,
    payload,
});

/**
 * Fire when API request fails
 */
const getTradeInDevicesFailed = () => ({
    type: GET_TRADE_IN_DEVICES_FAILED,
});

/**
 * set suggest field value
 * @param suggestFieldValue
 */
const setSuggestFieldValue = (suggestFieldValue: string) => ({
    type: SET_SUGGEST_FIELD_VALUE,
    suggestFieldValue,
});

/**
 * Toggle trade in switch
 */
const toggleTradeInSwitch = (force?: boolean) => ({
    type: TOGGLE_TRADE_IN_SWITCH,
    force,
});

/**
 * select device
 * @params selectedDeviceId
 */
const setSelectedTradeInDeviceId = (selectedDeviceId: string) => ({
    type: SET_TRADE_IN_DEVICE,
    selectedDeviceId,
});

/**
 * delete delcted device
 *
 */
const deleteSelectedDevice = () => ({
    type: DELETE_SELECTED_TRADE_IN_DEVICE,
});

/**
 * Action Creators Object
 */
export const tradeInActionCreators = {
    createInitialState,
    setDefaultState,
    getTradeInDevices,
    getTradeInDevicesSuccess,
    getTradeInDevicesFailed,
    setSuggestFieldValue,
    toggleTradeInSwitch,
    setSelectedTradeInDeviceId,
    deleteSelectedDevice,
};

/**
 * Action Dispatchers Object
 */
export const tradeInActionDispatchers = {
    createInitialState,
    getTradeInDevices,
    setSuggestFieldValue,
    toggleTradeInSwitch,
    setSelectedTradeInDeviceId,
    deleteSelectedDevice,
    triggerOverlay,
};

/**
 * Action Creators
 */
export type TradeInActionCreators = typeof tradeInActionCreators;

/**
 * Action Dispatchers
 */
export type TradeInActionDispatchers = typeof tradeInActionDispatchers;

/**
 * Union Action Type
 */
export type TradeInAction = ExtractActions<TradeInActionCreators>;
